import { FilterInputProps } from '@/components/table/_fieldDefinitions/_base/FilterInputProps.ts';
import MultiSelectInput from '@/components/form/MultiSelectInput.tsx';
import { EnumFieldDefinitionDto } from '@/components/table/_fieldDefinitions/enum/EnumFieldDefinitionDto.ts';
import { getEnumConfig } from '@/components/table/_fieldDefinitions/enum/enumRegistry.ts';
import Option from '@/components/form/types/Option.ts';

export const EnumFilterInputs = ({
  form,
  index,
  fieldDef,
}: FilterInputProps) => {
  let options: Option[] = [];
  if (fieldDef) {
    const enumField = fieldDef as EnumFieldDefinitionDto;
    const enumConfig = getEnumConfig(enumField.enumName);
    if (enumConfig) {
      options = Object.entries(enumConfig).map(([key, config]) => ({
        value: key,
        label: config.label,
      }));
    }
  }
  return (
    <MultiSelectInput
      controlSize="toolbar"
      placeholder="Wpisz wartość"
      fieldPath={`filters.${index}.value`}
      control={form.control}
      options={options}
    />
  );
};
